import { render, staticRenderFns } from "./details-row.vue?vue&type=template&id=aba30d48"
import script from "./details-row.vue?vue&type=script&lang=js"
export * from "./details-row.vue?vue&type=script&lang=js"
import style0 from "./details-row.vue?vue&type=style&index=0&id=aba30d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports